import React from 'react';
import styled from 'styled-components';
import Hypoxia from '../../components/Hypoxia/Hypoxia';
import Target from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';


const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:300px;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

    @media (max-width: 768px) {
    height: 60vh;

  }
`;



class CardHypoxia extends React.Component {
  render () {
   return (

<Container>
    
    <Viz>
      <Hypoxia />

    </Viz>

   <ReusableDetailCard
   trend= {Target}
   metricsm="Coastal regions, gulfs and estuaries"
   diagnosis="Hypoxic zones are areas in the ocean of such low oxygen concentration that animal life suffocates. Fertilizer runoff promotes algal overgrowth, which consumes available oxygen."
   prediction="Fish and shellfish stocks are reduced and destabilized as fewer reach adulthood. Less mobile  animals cannot move to waters with more oxygen and are often killed during hypoxic events (EPA)."
   significanceorthreat="SIGNIFICANCE"
   confidence="CONFICENCE LV: 95%"
   />
</Container>

  );
 }
}

export default CardHypoxia;
